'use client';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { AuthPanel } from './auth-panel';

/**
 * The error page with some humour (owner, 2026-11-03), the 404's sibling: a big 500 whose middle
 * zero breathes slowly, and a system having a hard day. The joke stays on the system, never on
 * the person: patients land here too, so it says plainly that it wasn't anything they did.
 */
export function ErrorNotice() {
  const t = useTranslations('appError');
  const credit = useTranslations('myPage');
  return (
    <AuthPanel
      footer={
        <footer className="px-4 pb-8 text-center text-xs text-muted-foreground">
          {credit.rich('madeWith', {
            brand: (chunks) => (
              <Link href="/" className="font-semibold text-foreground hover:underline">
                {chunks}
              </Link>
            ),
          })}
        </footer>
      }
    >
      <div className="space-y-8 text-center">
        <div aria-label="500" role="img" className="flex items-end justify-center gap-1 text-[7.5rem] font-bold leading-none tracking-[-0.04em] text-medlux">
          <span aria-hidden="true">5</span>
          <span aria-hidden="true" className="lanuq-breathe inline-block text-brand-lanuq">
            0
          </span>
          <span aria-hidden="true">0</span>
        </div>
        <div className="space-y-2">
          <h1 className="text-[1.5rem] font-bold tracking-[-0.01em] text-foreground">{t('title')}</h1>
          <p className="text-sm text-muted-foreground">{t('body')}</p>
        </div>
        {/* A full navigation, not a client one: whatever broke here does not come along. */}
        <a
          href="/"
          className="inline-block text-sm font-semibold text-foreground underline decoration-dotted decoration-2 underline-offset-4 hover:text-medlux"
        >
          {t('home')}
        </a>
      </div>
    </AuthPanel>
  );
}
